import { render } from "./HeroPage.vue?vue&type=template&id=69543ea1&scoped=true&ts=true"
import script from "./HeroPage.ts?vue&type=script&lang=ts"
export * from "./HeroPage.ts?vue&type=script&lang=ts"

import "./HeroPage.scss?vue&type=style&index=0&id=69543ea1&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69543ea1"]])

export default __exports__